import React from 'react';
import _ from 'lodash';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import Modal from '~/components/modal';
import { Select } from '~/components/form';

const Container = styled(Form)`
  display: flex;
  flex-direction: column;
  width: 100%;
`;

function AreaModal({ data, title, areas, isOpen, loading, closeModal, handleOnSubmit }) {

  let areasList = _.map(areas, (r) => { return { value: r, label: r }});
  areasList.unshift({ value: '', label: 'Não relacionado' })

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{}}
      >
      {({ values, isValid, touched, errors, handleReset }) => (
        <Modal
          width="560px"
          height="180px"
          hideClose={true}
          open={isOpen}
          hide={closeModal}
          title={title}
          actions={[
            {
              label: 'Cancelar',
              action: () => { handleReset() ; closeModal() },
              disabled: loading
            },
            {
              label: 'Salvar',
              action: () => handleOnSubmit(values),
              primary: true,
              disabled: loading
            }
          ]}
          >
          <Container>
            <Select
              name="area"
              label="Acesso"
              options={{ values: areasList }}
            />
          </Container>
        </Modal>
      )}
    </Formik>
  );
};

export default AreaModal;
